import { initializeLotteriesButtonsNavigation } from '../utils/custom-helpers';

import { $ } from './bootstrap';

import mapLotterySlugToMachine from 'components/draw-animation/services/mapLotterySlugToMachine';

$(function () {
    function adjustParentHeight() {
        const $parent = $('.custom-box-section');
        const $child = $parent.children();

        let isEmpty = true;
        $child.each(function () {
            if ($(this).text().trim() !== '') {
                isEmpty = false;
                return false;
            }
            return true;
        });

        if (isEmpty) {
            $parent.removeClass('container');
        }
    }
    adjustParentHeight();

    const maxTextAreaLength = parseInt($('#message-error').text().match(/\d+/));

    $('select.select2').select2();

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
    });

    $('.prevent-click').on('click', function (e) {
        e.preventDefault();
    });

    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip();

    $('.modal-close').on('click', function () {
        $(this).closest('.modal').modal('hide');
    });

    $('.modal').each(function () {
        if ($(this).data('show') === true) {
            $(this).modal();
        }
    });

    $('.modal').on('shown.bs.modal', function () {
        $(this).find('[autofocus]').focus();
    });

    $('.collapse').on('show.bs.collapse', function () {
        $(this).siblings('.h2-collapse').addClass('active');
    });

    $('.collapse').on('hide.bs.collapse', function () {
        $(this).siblings('.h2-collapse').removeClass('active');
    });

    const emailButton = $('.show_form_email');
    const phoneButton = $('.show_form_phone');
    $('.show_form_email, .show_form_phone').on('click', function (e) {
        const target = e.delegateTarget.classList.contains('show_form_email') ? 'email' : 'phone';

        if (target === 'email') {
            emailButton.addClass('is-active');
            phoneButton.removeClass('is-active');
        } else {
            emailButton.removeClass('is-active');
            phoneButton.addClass('is-active');
        }

        if (this.dataset.href) {
            window.location.href = this.dataset.href;

            e.preventDefault();
            return;
        }

        const form = $(this).closest('form');
        if (target === 'email') {
            form.find('.form-phone').removeClass('d-block').addClass('d-none');
            form.find('.form-email').removeClass('d-none').addClass('d-block');
            form.find('.phone_country').attr('disabled', true);
            form.find('.phone').attr('disabled', true);
            form.find('.email').attr('disabled', false);
        } else {
            form.find('.form-email').removeClass('d-block').addClass('d-none');
            form.find('.form-phone').removeClass('d-none').addClass('d-block');
            form.find('.phone_country').attr('disabled', false);
            form.find('.phone').attr('disabled', false);
            form.find('.email').attr('disabled', true);
        }
    });

    if ($('#facebook-modal').length) {
        setTimeout(function () {
            if ($('.modal.show').length === 0) {
                $('#facebook-modal').modal('show');
            }
        }, 10000);
    }

    if ($('#coming-soon-modal').length) {
        setTimeout(function () {
            if ($('.modal.show').length === 0) {
                $('#coming-soon-modal').modal('show');
            }
        }, 10000);
    }

    if ($('form#payment-redirect-form').length && $('span#payment-redirect-countdown').length) {
        initializeAutoRedirectForm($('form#payment-redirect-form'), $('span#payment-redirect-countdown'));
    }

    $('#message').on('input', function () {
        const message = $(this).val();

        if (message.length > maxTextAreaLength) {
            $(this).addClass('is-invalid').css('background-image', 'none');
            $('#message-error').show();
        } else {
            $(this).removeClass('is-invalid');
            $('#message-error').hide();
        }
    });

    $('#message').on('keydown', function (event) {
        const message = $(this).val();

        if (
            message.length >= maxTextAreaLength &&
            event.key !== 'Backspace' &&
            event.key !== 'Delete' &&
            !event.ctrlKey &&
            !event.metaKey
        ) {
            event.preventDefault();
        }
    });

    $('textarea')
        .each(function () {
            $(this).css('height', `${this.scrollHeight}px`).css('overflow-y', 'hidden');
        })
        .on('input', function () {
            if (this.value.length > maxTextAreaLength) {
                this.value = this.value.substring(0, maxTextAreaLength);
            }
            $(this).css('height', 0).css('height', `${this.scrollHeight}px`);
        })
        .css('resize', 'none');

    initializeStateSelect();
    initializeTogglePasswordVisibilityOption();

    $('.watch-the-draw-button').each(function () {
        $(this).toggle(!!mapLotterySlugToMachine($(this).data('lottery-slug')));
    });

    $('#modalTemplate[data-dismiss-redirect^=http]').each(function () {
        $(this).on('hidden.bs.modal', function () {
            window.location.href = $(this).data('dismiss-redirect');
        });
    });

    $('.disable-on-submit').each(function () {
        const $button = $(this);
        $button.closest('form').on('submit', () => $button.prop('disabled', true));
    });
});


// Deprecated
// Remove after register form is rewritten into React
$('.toggle-password-visibility-icon').on('click', function () {
    const passwordInput = $(this).prev('input');
    const type = passwordInput.attr('type') === 'password' ? 'text' : 'password';
    passwordInput.attr('type', type);
    $(this).toggleClass('fa-eye fa-eye-slash');
});

$('#register-form').submit(function () {
    $('#register-submit').prop('disabled', true);
});

function counterFinishedTextCallback(countdown) {
    const text = countdown.dataset.finishedText || '';
    const $textWrapper = countdown.dataset.finishedTextWrapper
        ? $(countdown.dataset.finishedTextWrapper, countdown)
        : '';

    if (text.length > 0 && $textWrapper.length > 0) {
        $('.countdown-title', countdown).hide();
        $textWrapper.html(text);

        setTimeout(function () {
            window.location.reload();
        }, 60000);
    }
}

// little trick to make it accesible from outside webpack compilation
window.counterFinishedTextCallback = counterFinishedTextCallback;

$(window).on('load', function () {
    initializeLotteriesButtonsNavigation();
});

$('#withdrawal_form').on('submit', function (event) {
    const $form = $(this);
    const hasActiveBonus = Number($form.attr('data-has-active-bonus') || 0) === 1;
    if (hasActiveBonus) {
        const confirmationMessage = $form.attr('data-active-bonus-confirmation');

        if (confirmationMessage && !window.confirm(confirmationMessage)) {
            event.preventDefault();
            return;
        }
    }

    $('#withdrawal-submit-button').addClass('disabled');
});

$('.bonus-cancel-form').on('submit', function (event) {
    const $form = $(this);
    const confirmationMessage = $form.data('cancelConfirmation');
    if (confirmationMessage && !window.confirm(confirmationMessage)) {
        event.preventDefault();
    }
});

function initializeStateSelect() {
    const $countrySelect = $('#country');
    const $stateSelect = $('#state');

    if ($countrySelect.length < 1 || $stateSelect.length < 1) {
        return;
    }

    $countrySelect.on('change', function () {
        $.ajax({
            type: 'GET',
            url: '/states',
            data: {
                country: this.value,
            },
            dataType: 'json',
            error: (data) => {
                console.error(`An error occurred while fetching states (Code: ${data.status})`);
            },
            success: (data) => {
                $stateSelect.find('option').not('.info').remove();
                $stateSelect.find('optgroup').remove();

                if (data.regions.length > 0 || data.sub_regions.length > 0) {
                    $(data.regions).each(function (index, item) {
                        $stateSelect.append(`<option value="${item.value}">${item.name} - ${item.type}</option>`);
                    });

                    $(data.sub_regions).each(function (index, item) {
                        const optgroup = $(`<optgroup label="${item.label}">`);
                        $(item.items).each(function (subIndex, subItem) {
                            optgroup.append(
                                `<option value="${subItem.value}">${subItem.name} - ${subItem.type}</option>`
                            );
                        });
                        $stateSelect.append(optgroup);
                    });

                    $stateSelect.prop('disabled', false);
                    $stateSelect.trigger('change');
                } else {
                    $stateSelect.prop('disabled', true);
                }

                if ($stateSelect.hasClass('old')) {
                    $stateSelect.find(`option[value=${$stateSelect.data('state')}]`).attr('selected', 'selected');
                }
            },
        });
    });

    $countrySelect.trigger('change');
}

$('.raffle-winning-tickets-collapse').click(function () {
    const id = $(this).attr('data-id');
    $(`#prize-${id}`).toggleClass('d-none');
});

/**
 * Check if promo code field is filled but not applied.
 * If is not applied aks user if it's intentionally.
 *
 * @return boolean
 */
export function checkPromoCodeField() {
    const $promoCodeWrapper = $('#promo-code');

    if ($promoCodeWrapper.length) {
        const $field = $('#promo_code', $promoCodeWrapper);

        if ($field.length > 0 && $field.val().length > 0) {
            return window.confirm($('#promo-code-not-applied-question', $promoCodeWrapper).text());
        }
    }

    return true;
}
window.checkPromoCodeField = checkPromoCodeField;

function initializeTogglePasswordVisibilityOption() {
    const $fields = $('input[type="password"]');
    if (!$fields.length) {
        return;
    }

    $fields.each(function () {
        if (this.nextElementSibling) {
            this.nextElementSibling.addEventListener('click', (event) => {
                if (event.target.nodeName === 'input') {
                    if (this.type === 'password') {
                        this.type = 'text';
                        event.target.classList.add('fa-eye-slash');
                        event.target.classList.remove('fa-eye');
                    } else {
                        this.type = 'password';
                        event.target.classList.add('fa-eye');
                        event.target.classList.remove('fa-eye-slash');
                    }
                }
            });
        }
    });
}

function initializeAutoRedirectForm($form, $countdown) {
    const countdownProgress = (value) => {
        $countdown.text(value);
        if (value > 0) {
            setTimeout(() => countdownProgress(value - 1), 1000);
        } else {
            $form.submit();
        }
    };
    countdownProgress(parseInt($countdown.text()) || 5);
}

function lazyLoad() {
    const images = document.querySelectorAll('.lazyLoad');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.src = entry.target.dataset.src;
                entry.target.classList.add('fade-in');
                observer.unobserve(entry.target);
            }
        });
    });
    images.forEach((image) => {
        observer.observe(image);
    });
}

lazyLoad();

document.getElementById('provider-filter-on-casino-home')?.addEventListener('change', function () {
    const selectedProvider = this.value;
    if (selectedProvider) {
        window.location.href = selectedProvider;
    }
});

$('.printable-button').on('click', function () {
    window.print();
    return false;
});

$(() => {
    const $openVoucherModal = $('#open-voucher-modal');
    $('a.confirm-voucher-opening').each(function () {
        const $link = $(this);
        $link.on('click', (event) => {
            event.preventDefault();
            $openVoucherModal.data('voucher-url', $link.attr('href')).modal('show');
        });
    });
    $openVoucherModal.find('button.confirm-opening').on('click', () => {
        const voucherUrl = $openVoucherModal.data('voucher-url');
        $(`a[href="${voucherUrl}"]`).remove();
        window.open(voucherUrl, '_blank');
        $openVoucherModal.modal('hide');
    });
});

document.getElementById('showMoreLotteriesButton')?.addEventListener('click', function () {
    document.querySelectorAll('.lottery-list-item.is-hidden').forEach(function (el) {
        el.classList.remove('is-hidden');
    });
    this.style.display = 'none';
});

document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("modalTemplate");
    if (!modal) return;

    const closeButtons = modal.querySelectorAll('[data-bs-dismiss="modal"]');

    closeButtons.forEach(button => {
        button.addEventListener("click", function () {
            modal.classList.remove("d-block");

            const redirectUrl = modal.getAttribute("data-dismiss-redirect");
            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.float-images-container');
    if (!container) return;

    const images = container.querySelectorAll('img:not(.img-center)');
    images.forEach((img, index) => {
        img.classList.add(index % 2 === 0 ? 'img-left' : 'img-right');
    });
});
